import { render, staticRenderFns } from "./ReportLeadsPage.vue?vue&type=template&id=6a5eddb4&scoped=true&"
import script from "./ReportLeadsPage.vue?vue&type=script&lang=js&"
export * from "./ReportLeadsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5eddb4",
  null
  
)

export default component.exports